import React, { useState } from 'react'
import { api } from '../../utils/api'

// The buyer's name and address for a case's marketplace order. Nothing loads
// until staff click: that read is what Prism logs as a personal-data view, and
// the name and address are never sent to the browser before it.
function CaseCustomerDetails({ marketplace, orderNumber }) {
  const [order, setOrder] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  async function showDetails() {
    setLoading(true)
    setError(null)
    try {
      const response = await api.get(`/api/orders/detail/${marketplace}/${encodeURIComponent(orderNumber)}`)
      setOrder(response.order)
    } catch (err) {
      setError(err.message || 'Could not load customer details')
    } finally {
      setLoading(false)
    }
  }

  if (!order) {
    return (
      <div>
        <button className="btn btn-sm btn-secondary" onClick={showDetails} disabled={loading}>
          {loading ? 'Loading...' : 'Show customer details'}
        </button>
        {error && <span role="alert" style={{ marginLeft: 8, color: '#b91c1c', fontSize: 12 }}>{error}</span>}
      </div>
    )
  }

  const address = order.shipping_address || {}
  const name = address.shipping_name
    || [order.customer?.first_name, order.customer?.last_name].filter(Boolean).join(' ')
  const addressLine = [address.address1, address.address2, address.city, address.province, address.zip, address.country_code]
    .filter(Boolean)
    .join(', ')

  return (
    <div>
      <div><strong>Name:</strong> <span>{name || 'No name on the order'}</span></div>
      <div><strong>Address:</strong> <span>{addressLine || 'No address on the order'}</span></div>
      {address.phone && <div><strong>Phone:</strong> <span>{address.phone}</span></div>}
    </div>
  )
}

export default CaseCustomerDetails
